import { Stack } from '@mui/material';
import { Section } from 'modules/common/components/Section';
import { useTranslation } from 'modules/i18n';
import { WithdrawalForm } from './components/WithdrawalForm';
import { translation } from './translation';
import { VaultContextProvider } from 'modules/dashboard/components/Deposit/VaultContextProvider';
import { dashboardRouteConfig } from 'modules/dashboard';
import { ScreenCard } from './components/ScreenCard';
import { ConnectionGuard } from 'modules/auth';
import { WithdrawalGuard } from './components/WithdrawalGuard';
import { WrongNetworkGuard } from 'modules/auth/screens/WrongNetworkGuard';
import { OChainId } from 'modules/api';

export function Withdraw() {
  const { t, keys } = useTranslation(translation);

  return (
    <ConnectionGuard>
      <WrongNetworkGuard expectedChainIds={[OChainId.ethereum, OChainId.sonic]}>
        <VaultContextProvider>
          <WithdrawalGuard>
            <Section>
              <Stack justifyContent="center" alignItems="center">
                <ScreenCard
                  title={t(keys.title)}
                  backBtn={{
                    to: dashboardRouteConfig.main.generatePath(),
                    label: t(keys.back),
                  }}
                >
                  <WithdrawalForm />
                </ScreenCard>
              </Stack>
            </Section>
          </WithdrawalGuard>
        </VaultContextProvider>
      </WrongNetworkGuard>
    </ConnectionGuard>
  );
}
